import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getPayrollBusinessRules = ({ payrollScheduleId }) =>
  call(websocketFetch, 'get_payroll_business_rules', {
    payroll_schedule_id: payrollScheduleId,
  });
